import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import Button from "../button";
import { uploadDocument } from "../../store/action";
import { useHistory } from "react-router-dom";

const UploadFormContainer = ({ buttonLabel }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const fileInputEl = useRef(null);

  const handleChange = (e) => {
    const document = e.target.files[0];
    dispatch(uploadDocument(document));
    history.push("/result");
  };

  const handleClick = (e) => {
    fileInputEl.current.click();
  };

  return (
    <React.Fragment>
      <Button onClick={handleClick}>{buttonLabel}</Button>
      <input
        type="file"
        accept="image/*,.pdf"
        ref={fileInputEl}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </React.Fragment>
  );
};

export default UploadFormContainer;
